import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import SelectAllButton from './SelectAllButton';
import FilterInputs from './FilterInputs';
import ActionButtons from './ActionButtons';

const FilterControls = ({ 
  statusFilter, selectedAccounts, filteredData, toggleSelectAll, selectedManufacturer, 
  setSelectedManufacturer, availableManufacturers, dateFilter, setDateFilter, 
  accountNameFilter, setAccountNameFilter, tabValue, fetchPaginatedData, 
  setStatusFilter, canEdit, setAddDialogOpen, setLabelDialogOpen, bulkDeleteAccounts, pageSize 
}) => (
  <Grid
    container
    spacing={2}
    sx={{
      alignItems: "center",
      flexWrap: 'nowrap',
      overflowX: 'auto'
    }}>
    <SelectAllButton 
      selectedAccounts={selectedAccounts}
      filteredData={filteredData}
      toggleSelectAll={toggleSelectAll}
    />
    <FilterInputs 
      selectedManufacturer={selectedManufacturer}
      setSelectedManufacturer={setSelectedManufacturer}
      availableManufacturers={availableManufacturers}
      dateFilter={dateFilter}
      setDateFilter={setDateFilter}
      accountNameFilter={accountNameFilter}
      setAccountNameFilter={setAccountNameFilter}
      tabValue={tabValue}
      fetchPaginatedData={fetchPaginatedData}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      pageSize={pageSize}
    />
    <ActionButtons 
      canEdit={canEdit}
      setAddDialogOpen={setAddDialogOpen}
      setLabelDialogOpen={setLabelDialogOpen}
      selectedAccounts={selectedAccounts}
      bulkDeleteAccounts={bulkDeleteAccounts}
    />
  </Grid>
);

FilterControls.propTypes = {
  statusFilter: PropTypes.string.isRequired,
  selectedAccounts: PropTypes.array.isRequired,
  filteredData: PropTypes.array.isRequired,
  toggleSelectAll: PropTypes.func.isRequired,
  selectedManufacturer: PropTypes.string.isRequired,
  setSelectedManufacturer: PropTypes.func.isRequired,
  availableManufacturers: PropTypes.array.isRequired,
  dateFilter: PropTypes.object.isRequired,
  setDateFilter: PropTypes.func.isRequired,
  accountNameFilter: PropTypes.string.isRequired,
  setAccountNameFilter: PropTypes.func.isRequired,
  tabValue: PropTypes.number.isRequired,
  fetchPaginatedData: PropTypes.func.isRequired,
  setStatusFilter: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  setAddDialogOpen: PropTypes.func.isRequired,
  setLabelDialogOpen: PropTypes.func.isRequired,
  bulkDeleteAccounts: PropTypes.func.isRequired,
  pageSize: PropTypes.number.isRequired
};

export default FilterControls;